/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { Grid, Container } from "@material-ui/core";
import { useParams } from "react-router";
import PageTitle from "../../components/pageTitle/PageTitle";
import CommonContext from "../../hooks/commonContext";
import { getAllEmployee } from "../../services/apiservices/employee";
import confirm from "../../components/DialogComponent/confirm";
import { useNavigate } from "react-router";
import {
  saveChannel,
  getChannel,
  updateChannel,
} from "../../services/apiservices/messages";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../hooks/authContext";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Plus } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textArea";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import MultiSelectWithCheckbox from "../../components/SelectField/MulitpleSelectNew";
import { Label } from "../../components/ui/label";
import { useToast } from "../../hooks/useToast";
import { trackEvent, CMS_EVENTS } from "../../services/apiservices/analytics";

const GroupType = [
  { value: "Public", label: "Public Group" },
  { value: "Private", label: "Private Group" },
];
function CreateChannel(props) {
  const commonContext = useContext(CommonContext);
  const history = useNavigate();
  const { channelId } = useParams();
  const [formerror, setFormError] = useState({});
  const [formdata, setFormData] = useState({ groupType: "Private" });
  const auth = useContext(AuthContext);
  const [audienceList, setAudienceList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [clientChannel, setClientChannel] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const { toast } = useToast();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const setIsLoading = (status) => {
    commonContext.setLoader(status);
  };

  const getChannelDetails = (channelId) => {
    if (typeof channelId !== "undefined" && channelId !== "") {
      commonContext?.setLoader(true);
      getChannel(
        channelId,
        (res) => {
          if (res?.status === true) {
            const audList = [];
            const selectedEmp = res?.data?.employee?.map((itm) => {
              audList.push(itm);
              return itm.id;
            });
            setAudienceList(audList);
            setClientChannel(res?.data?.clientChannel || false);
            setFormData({
              ...res?.data,
              groupName: res?.data.groupName,
              selectedClient: res?.data?.client,
              selectedEmployees: selectedEmp,
              groupType: res?.data.type,
              message: res?.data.description,
              channelId: channelId,
            });
          }
          commonContext?.setLoader(false);
        },
        (resError) => {
          if (resError?.error === "Channel not found") {
            history("/communications/message-board/manage-channel");
          }
          commonContext?.setLoader(false);
        }
      );
    } else {
      setFormData({ groupType: "Private" });
      commonContext?.setLoader(false);
    }
  };
  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });
  };

  const clearformdata = () => {
    setFormData({ groupType: "Private" });
    setFormError({});
    setAudienceList([]);
  };

  const fetchData = async () => {
    setIsLoading(true);

    if (auth?.userProfile?.role === "Client") {
      setClientChannel(true);
    }

    await getAllEmployee(
      (res) => {
        if (res) {
          const filteredClients = res?.data?.filter(
            (item) =>
              item?.role === "Client" &&
              item.status !== false &&
              item.companyId === companyId
          );
          setClientList(filteredClients);

          const data = res?.data?.filter(
            (item) =>
              (
                (Array.isArray(item.role) && item.role.includes("Employee")) ||
                item.role === "Employee"
              ) &&
              item.status !== false &&
              item.companyId === companyId
          );
          let allEmp = data?.map((eitem) => {
            return {
              ...eitem,
              userName: `${eitem?.firstName} ${eitem?.lastName}`,
            };
          });
          setEmployeeList(allEmp);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      },
      (resError) => {
        console.log("reserror", resError);
        setIsLoading(false);
      }
    );
  };
  useEffect(() => {
    getChannelDetails(channelId);
  }, [channelId]);

  useEffect(() => {
    setIsLoading(true);
    clearformdata();
    setAudienceList([]);
    fetchData();

    setIsLoading(false);
  }, []);

  const handlefieldChange = (name, value) => {
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });

    if (name === "selectedEmployees" && value) {
      const empList = employeeList.filter((emp) => value.includes(emp.id));
      setAudienceList([
        ...empList?.map((aitem) => {
          return {
            firstName: aitem.firstName,
            lastName: aitem.lastName,
            id: aitem.id,
            email: aitem.email,
            phone: aitem.phoneNumber,
          };
        }),
      ]);
    }
  };

  const checkValid = () => {
    let errormessages = formerror;
    let isValid = true;
    if (
      typeof formdata?.groupName === "undefined" ||
      formdata?.groupName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        groupName: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, groupName: "" };
    }
    if (formdata.groupType === "Private") {
      if (audienceList.length <= 0) {
        isValid = false;
        errormessages = {
          ...errormessages,
          selectedEmployees:
            "Please Add employees By Name/By Client/By Group First!",
        };
      } else {
        errormessages = { ...errormessages, selectedEmployees: "" };
      }
    } else {
      errormessages = { ...errormessages, selectedEmployees: "" };
    }
    if (typeof formdata?.message === "undefined" || formdata?.message === "") {
      isValid = false;
      errormessages = {
        ...errormessages,
        message: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, message: "" };
    }

    if (clientChannel) {
      if (formdata?.selectedClient === "undefined" || !formdata?.selectedClient) {
        isValid = false;
        errormessages = { ...errormessages, selectedClient: "Client is required" };
      } else {
        errormessages = { ...errormessages, selectedClient: "" };
      }
    } else {
      errormessages = { ...errormessages, selectedClient: "" };
    }

    setFormError(errormessages);
    return isValid;
  };

  const onSaveChannel = () => {
    if (true === checkValid()) {
      setIsLoading(true);
      let formDataSave = {
        groupName: formdata?.groupName,
        description: formdata?.message,
        client: clientChannel ? formdata?.selectedClient : null,
        clientChannel: clientChannel,
        type: clientChannel ? "Private" : formdata?.groupType,
        companyId: companyId,
        status: true,
        employee: audienceList
          ? audienceList?.map((empitem) => {
            return {
              id: empitem.id,
              firstName: empitem.firstName,
              lastName: empitem.lastName,
              email: empitem.email,
              phone: empitem.phone,
            };
          })
          : [],
      };

      if (typeof channelId === "undefined" || channelId === "") {
        saveChannel(
          formDataSave,
          (res) => {
            if (res.status === true) {
              setIsLoading(false);
              history("/communications/message-board/manage-channel");
              toast?.({ title: "Success", description: "Channel Created Successfully", });
              trackEvent(CMS_EVENTS.CHANNEL_CREATED, {
                channel_name: formDataSave.groupName,
              });
            }
          },
          (errorRes) => {
            setIsLoading(false);
            console.log("error while save notification", errorRes);
          }
        );
      } else {
        updateChannel(
          channelId,
          formDataSave,
          (res) => {
            if (res.status === true) {
              setIsLoading(false);
              history("/communications/message-board/manage-channel");
              toast?.({ title: "Success", description: "Channel Updated Successfully", });
              trackEvent(CMS_EVENTS.CHANNEL_UPDATED, {
                channel_id: channelId,
                channel_name: formDataSave.groupName,
              });
            }
          },
          (errorRes) => {
            setIsLoading(false);
            console.log("error while save notification", errorRes);
          }
        );
      }
    }
  };

  let allempoptions = employeeList?.map((item) => {
    return { label: item.firstName + item.lastName, value: item.id };
  });

  let allclientoptions = [];

  if (auth?.userProfile?.role === "Client") {
    allclientoptions = [
      {
        label: `${auth?.userProfile?.firstName}`,
        value: auth?.userProfile?.client,
      },
    ];
  } else {
    allclientoptions = clientList?.map((item) => ({
      label: `${item?.firstName}`,
      value: item?.id,
    }));
  }

  return (
    <Container>
      <PageTitle
        pageTitle={clientChannel ? "Create Client Channel" : "Create Channel"}
        showBreadcrumb={[{ label: "Home", to: "/" }]}
        showLastSeen={true}
      />
      <div className="p-24">
        <div className="flex items-center justify-between mb-24">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">
              Create Channel
            </h1>
            <p className="text-muted-foreground">
              Create a new channel for your team to communicate
            </p>
          </div>
        </div>
        <div className="max-w-2xl">
          <Card className="p-24 bg-white shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader
              className={
                isMobile
                  ? "d-flex mb-20"
                  : "d-flex flex-direction-row flex-space-between mb-20"
              }
            >
              <div>
                <CardTitle className="flex items-center gap-2">
                  <Plus className="h-5 w-5" />
                  <span>New Channel</span>
                </CardTitle>
                <CardDescription className="mt-8">
                  Fill out the form below to create a new communication channel
                </CardDescription>
              </div>
              {auth?.userProfile?.role === "Client" || !channelId && (
                <div>
                  <Link
                    onClick={() => setClientChannel(!clientChannel)}
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#353535",
                      padding: "0px",
                      textDecoration: "underline",
                      color: "blue",
                    }}
                  >
                    {clientChannel ? "Create Channel" : "Create Client Channel"}
                  </Link>
                </div>
              )}
            </CardHeader>
            <CardContent>
              <Label htmlFor="channelName">Group Name</Label>
              <div className="mb-20 mt-10">
                <Input
                  fullWidth={true}
                  size="small"
                  name="groupName"
                  id="groupName"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={formdata.groupName}
                  onChange={handleInputChange}
                  placeholder="Enter Group Name"
                />
                {typeof formerror?.groupName !== "undefined" &&
                  formerror?.groupName !== "" && (
                    <span className="small error color-danger">
                      {formerror?.groupName}
                    </span>
                  )}
              </div>
              {!clientChannel && (
                <>
                  <Label>Type</Label>
                  <div className="mb-20 mt-10">
                    <SingleSelectNew
                      className={`field`}
                      name={"groupType"}
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      InputLabelProps={{ shrink: true }}
                      value={formdata.groupType}
                      onChange={(e) => handlefieldChange("groupType", e)}
                      options={GroupType}
                    />
                  </div>
                </>
              )}
              {clientChannel && (
                <>
                  <Label>Select Client</Label>
                  <div className="mb-20 mt-10">
                    <SingleSelectNew
                      label="Select Client"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      value={formdata?.selectedClient}
                      InputLabelProps={{ shrink: true }}
                      fullWidth={true}
                      className={`field`}
                      name={"selectedClient"}
                      onChange={(e) => handlefieldChange("selectedClient", e)}
                      options={allclientoptions}
                    />
                    <br />
                    {typeof formerror?.selectedClient !== "undefined" &&
                      formerror?.selectedClient !== "" && (
                        <span className="small error color-danger">
                          {formerror?.selectedClient}
                        </span>
                      )}
                  </div>
                </>
              )}
              {formdata.groupType === "Private" && (
                <>
                  <Label>Find Employee By Name</Label>
                  <div className="mb-20 mt-10">
                    <MultiSelectWithCheckbox
                      label="Find Employees by Name"
                      value={
                        formdata?.selectedEmployees
                          ? [...formdata?.selectedEmployees]
                          : []
                      }
                      InputLabelProps={{ shrink: true }}
                      fullWidth={true}
                      className={`field`}
                      name={"selectedEmployees"}
                      onChange={(val) =>
                        handlefieldChange("selectedEmployees", val)
                      }
                      options={[...allempoptions]}
                    />
                    <br />
                    {typeof formerror?.selectedEmployees !== "undefined" &&
                      formerror?.selectedEmployees !== "" && (
                        <span className="small error color-danger">
                          {formerror?.selectedEmployees}
                        </span>
                      )}
                  </div>
                </>
              )}
              <Grid container className="message_container">
                <Grid item sm={12} md={12} className="w-100">
                  <Textarea
                    value={formdata?.message ? formdata?.message : ""}
                    onChange={(e) =>
                      handlefieldChange("message", e.target.value)
                    }
                    fullWidth={true}
                    id="message"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Type Description Here"
                    multiline
                    rows={4}
                    // defaultValue="Type Your message here"
                    variant="outlined"
                  />
                  {typeof formerror?.message !== "undefined" &&
                    formerror?.message !== "" && (
                      <span className="small error color-danger">
                        {formerror?.message}
                      </span>
                    )}
                </Grid>
              </Grid>
            </CardContent>
            <CardFooter className="flex justify-end mt-20 gap-2">
              <Button onClick={onSaveChannel}>Create Channel</Button>
              <Button onClick={clearformdata}>Reset</Button>
              <Button
                variant="outline"
                onClick={async () => {
                  try {
                    const result = await confirm(
                      "Are you sure you want to cancel? This won't be saved or sent."
                    );

                    if (result) {
                      history("/communications/message-board/manage-channel");
                    }
                  } catch (err) {
                    console.log("Dialog closed or error:", err);
                  }
                }}
              >
                Cancel
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default CreateChannel;
